var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info_soft"},[_c('div',{staticClass:"container",staticStyle:{"padding":"0px","max-width":"100%"}},_vm._l((this.items),function(t){return _c('div',{key:t.name},[_c('div',{staticClass:"soft_title"},[_vm._v(" "+_vm._s(t.name)+" ")]),_c('b-img',{staticClass:"w-100",attrs:{"fluid":"","src":t.pic}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }